import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { QuestionsService } from 'src/app/services/questions.service';
import { StateManagementService } from 'src/app/services/state-management.service';

@Component({
  selector: 'app-submit-test',
  standalone: true,
  imports: [],
  templateUrl: './submit-test.component.html',
  styleUrl: './submit-test.component.scss'
})
export class SubmitTestComponent implements OnInit, OnDestroy {
  totalQuestions: number = 0;
  attemptedQuestions: number = 0;
  unansweredQuestions: number = 0;
  attemptedQuestionCountSubscription$: Subscription;


  constructor (
    private questionsService: QuestionsService,
    private stateManagementService: StateManagementService
  ){}

  ngOnInit(): void {
    this.totalQuestions = this.questionsService.totalQuestions;
    this.attemptedQuestionCountSubscription$ = this.questionsService.attemptedQuestionCount$
      .subscribe({
        next: (attemptedQuestionCount) => {
          this.attemptedQuestions = attemptedQuestionCount
          this.unansweredQuestions = this.totalQuestions - attemptedQuestionCount
        }
      })
  }

  ngOnDestroy(): void {
    this.stateManagementService.isSubmitTestRouteAllowed = false;
    this.attemptedQuestionCountSubscription$?.unsubscribe();
  }
}
